import React, { useState, useEffect } from "react";

//components
import CustomBreadcrumbs from "../../Components/CustomBreadcrumbs";
import DashboardHeader from "../../ClientEngagement/DashboardHeader";
import CustomFileDropper from "../../Components/CustomFileDropper";

//utils
import { axiosInstance } from "../../utils/axiosInterceptor";
import {
  Box,
  createTheme,
  ThemeProvider,
  Grid,
  Tooltip,
  Typography,
  Slider,
  Button,
} from "@mui/material";
import { MenuItem } from "@material-ui/core";
import { pcbData } from "./createProject.data";
// import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router-dom";

//styles
import {
  PageContainer,
  CreateProjectContainer,
  CreateProjectFormContainer,
  CusotmGridItem,
  CustomInput,
  CustomSelect,
  CustomButton,
} from "./CreateNewProject.styles";

//assets

const dropzoneTheme = createTheme({
  overrides: {
    root: {
      backgroundColor: "transparent",
    },
  },
});

const CreateFabProject = ({ isAdmin }) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [gerberFile, setGerberFile] = useState(null);
  const [createLoading, setCreateLoading] = useState(false);
  const [projectData, setProjectData] = useState({
    pcbQuantity: 0,
    projectName: "",
    surfaceFinish: "",
    deliveryFormat: "",
    isStencil: "",
    otherSpecification: "",
  });
  const [errors, setErrors] = useState({
    pcbQuantityError: false,
  });
  const [userEmail, setUserEmail] = useState("");

  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const fetchProfile = () => {
    setLoading(true);
    axiosInstance
      .get("/users/getProfile")
      .then((resp) => {
        setProfile(resp.data);
        console.log(resp);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    setProjectData({
      ...projectData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    //pcbQuantity check
    if (isNaN(Number(projectData.pcbQuantity)) || Number(projectData.pcbQuantity) < 5) {
      setErrors({
        ...errors,
        pcbQuantityError: true,
      });

      if(isNaN(Number(projectData.pcbQuantity))){
        enqueueSnackbar("pcbQuantity should be a valid number", {
          variant: "error",
        });
      }else{
        enqueueSnackbar("Pcb quantity should be greater than or equal to 5",{variant:"error"});
      }

      return;
    }

    if (gerberFile === null || projectData.colour == "") {
      if (gerberFile === null) {
        enqueueSnackbar("Please upload gerber file.", { variant: "info" });
        return;
      }
    }
    let formData = new FormData();
    formData.append("fab", gerberFile);
    // formData.append("printingService", projectData.printingService);
    for (let i in projectData) {
      formData.append(i, projectData[i]);
    }

    for (let pair of formData.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }
    setCreateLoading(true);
    const token = localStorage.getItem("token");
    try {
      let url;
      if (isAdmin) {
        url = "/3d/admin/createProject/injectionMolding";
        formData.append("userEmail", userEmail);
      } else {
        url = "/fab/client/createProject";
      }
      const res = await axiosInstance.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-type": "multipart/form-data",
        },
      });
      console.log(res);
      enqueueSnackbar("Project Created Successfully!", {
        variant: "success",
      });
      setCreateLoading(false);
      if (isAdmin) {
        history.push(
          `/admin/3d/timeline/injectionMolding/${res.data.newProj._id}`
        );
      } else {
        history.push(`/pcbFabTimeline/${res.data.newProj._id}`);
      }
    } catch (err) {
      console.log(e);
      enqueueSnackbar("some error occurred", { variant: "error" });
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <Box>
      {!loading ? (
        <PageContainer>
          <DashboardHeader profile_data={profile.data} isBlack={true} />
          <CreateProjectContainer>
            <CustomBreadcrumbs
              data={[
                {
                  name: "Home",
                  link: "/",
                },
                {
                  name: "EB PCB Fabricator",
                  link: "/pcbFabricator",
                },
                {
                  name: "Create new project",
                  link: "/pcbFabNewProject",
                },
              ]}
            />
            <div className="title">Create new Project - PCB Fabricator</div>
            <CreateProjectFormContainer>
              <div className="dropzone-container">
                <CustomFileDropper
                  setFile={setGerberFile}
                  single
                  headerText="Drag and drop to upload a file"
                  subText="Only .zip and .rar files are accepted. Maximum file size: 20mb"
                />
              </div>
              <form onSubmit={handleFormSubmit}>
                <Grid container spacing={5}>
                  <CusotmGridItem item md={6} xs={12}>
                    <div className="grid-item-inner">
                      <label htmlFor="project-name">Project Name*</label>
                      <CustomInput
                        type="text"
                        id="project-name"
                        name="projectName"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </CusotmGridItem>
                  <CusotmGridItem item md={6} shift xs={0}></CusotmGridItem>
                  <CusotmGridItem item md={6}>
                    <div className="grid-item-inner">
                      <label htmlFor="pcbQuantity">Quantity*</label>
                      <CustomInput
                        type="text"
                        id="pcbQuantity"
                        name="pcbQuantity"
                        placeholder="Min 5"
                        required
                        onChange={handleChange}
                        error={errors.pcbQuantityError}
                      />
                    </div>
                  </CusotmGridItem>
                  <CusotmGridItem item md={6} shift></CusotmGridItem>{" "}
                  <CusotmGridItem item md={6} xs={12} >
                    <div className="grid-item-inner">
                      <label htmlFor="surfaceFinish">Surface Finish*</label>
                      <CustomSelect
                        variant="outlined"
                        id="surfaceFinish"
                        required
                        name="surfaceFinish"
                        onChange={handleChange}
                      >
                        {pcbData.surfaceFinish.map((material) => (
                          <MenuItem value={material}>{material}</MenuItem>
                        ))}
                      </CustomSelect>
                    </div>
                  </CusotmGridItem>
                  <CusotmGridItem item md={6} shift xs={12} >
                    <div className="grid-item-inner">
                      <label htmlFor="deliveryFormat">Delivery Format*</label>
                      <CustomSelect
                        variant="outlined"
                        id="deliveryFormat"
                        required
                        name="deliveryFormat"
                        onChange={handleChange}
                      >
                        {pcbData.deliveryFormat.map((material) => (
                          <MenuItem value={material}>{material}</MenuItem>
                        ))}
                      </CustomSelect>
                    </div>
                  </CusotmGridItem>
                  <CusotmGridItem item md={6} xs={12} >
                    <div className="grid-item-inner">
                      <label htmlFor="isStencil">Stencil Requirement*</label>
                      <CustomSelect
                        variant="outlined"
                        id="isStencil"
                        required
                        name="isStencil"
                        onChange={handleChange}
                      >
                        {pcbData.stencilRequired.map((material) => (
                          <MenuItem value={material}>{material}</MenuItem>
                        ))}
                      </CustomSelect>
                    </div>
                  </CusotmGridItem>
                  {isAdmin ? (
                    <CusotmGridItem item md={6}>
                      <div className="grid-item-inner">
                        <label htmlFor="user-email">User Email*</label>
                        <CustomInput
                          type="text"
                          id="user-email"
                          name="userEmail"
                          onChange={(e) => {
                            setUserEmail(e.target.value);
                          }}
                          required
                          value={userEmail}
                        />
                      </div>
                    </CusotmGridItem>
                  ) : null}
                  <CusotmGridItem item md={12} isLast>
                    <div className="grid-item-inner">
                      <label htmlFor="otherSpecification">
                        Anyother Specification
                      </label>
                      <CustomInput
                        type="text"
                        id="otherSpecification"
                        name="otherSpecification"
                        onChange={handleChange}
                        multiline
                        rows={4}
                        placeholder="Additional Service may include in - fill, support, surface finishing, polishing, drilling and treading, tapping, beading and blasting etc"
                      />
                    </div>
                  </CusotmGridItem>
                </Grid>
                <CustomButton
                  variant="contained"
                  type="submit"
                  loading={createLoading}
                  loadingPosition="end"
                >
                  Submit
                </CustomButton>
              </form>
            </CreateProjectFormContainer>
          </CreateProjectContainer>
        </PageContainer>
      ) : null}
    </Box>
  );
};

export default CreateFabProject;
